// extracted by mini-css-extract-plugin
export default {"page":"qS4vEF"};